"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var CompletedProjectsService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ContractService /> class.
     * @param http
     * @param config
     */
    function CompletedProjectsService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * List available industry sectors
     */
    CompletedProjectsService.prototype.ListIndustriesAsync = function () {
        return this.http.get(this.config.DeliverablesApiURL + "/api/completedprojects/industries")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Completed projects.
     * @param page
     * @param pageSize
     * @param fromDate
     * @param toDate
     * @param feedId
     * @param module
     * @param productClassId
     * @returns An Observable containing a model.IPagedList<SimpleDProject>
     */
    CompletedProjectsService.prototype.ListAsync = function (page, pageSize, fromDate, toDate, feedId, moduleId, productClassIds, productVariantIds, textSearch, industry) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (moduleId)
            params = params.set('moduleId', moduleId);
        if (productClassIds)
            params = params.set('productClassIds', productClassIds);
        if (productVariantIds)
            params = params.set('productVariantIds', productVariantIds);
        if (textSearch)
            params = params.set('textSearch', textSearch);
        if (industry)
            params = params.set('industry', industry);
        return this.http.get(this.config.DeliverablesApiURL + "/api/completedprojects/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    CompletedProjectsService.ngInjectableDef = i0.defineInjectable({ factory: function CompletedProjectsService_Factory() { return new CompletedProjectsService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: CompletedProjectsService, providedIn: "root" });
    CompletedProjectsService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], CompletedProjectsService);
CompletedProjectsService.ɵfac = function CompletedProjectsService_Factory(t) { return new (t || CompletedProjectsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
CompletedProjectsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CompletedProjectsService, factory: function (t) { return CompletedProjectsService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CompletedProjectsService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return CompletedProjectsService;
}());
exports.CompletedProjectsService = CompletedProjectsService;

